module.exports = __webpack_public_path__ + "assets/images/kalender-overskuelig-planlaegning.jpg";